"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "faq-1",
  number: "01",
  question: "What type of coverage interests you most?",
  answer: <>
        We offer several options including{" "}
        <Link to="/HomePage" className="text-primary hover:underline font-medium">
          Term Life Insurance
        </Link>{" "}
        for temporary needs, Whole Life for permanent protection, and Final Expense for end-of-life costs. If you are not sure, our agents can help you decide.
      </>
}, {
  id: "faq-2",
  number: "02",
  question: "What is your primary reason for seeking life insurance?",
  answer: <>
        Most clients seek to protect family income, cover final expenses, pay off debts, or leave an inheritance. We also provide business protection solutions for entrepreneurs and partners.
      </>
}, {
  id: "faq-3",
  number: "03",
  question: "How much coverage are you looking for?",
  answer: <>
        Coverage amounts typically range from under $100,000 to over $1,000,000. The right amount depends on your financial obligations and the future needs of your beneficiaries.
      </>
}, {
  id: "faq-4",
  number: "04",
  question: "What information is required for a quote?",
  answer: <>
        To provide an accurate quote, we will need your Full Name, Phone Number, Email Address, Date of Birth, and State of Residence. This helps us determine eligibility and state-specific rates.
      </>
}, {
  id: "faq-5",
  number: "05",
  question: "Is the application process complicated?",
  answer: <>
        Not at all. LIFECOVER focuses on a simplistic, high-quality experience. Our questionnaire is designed to be straightforward, asking only the essential questions to get you the protection you need without unnecessary steps.
      </>
}];
export default function CommonQuestions() {
  return <section data-section-id="234921" id="common-questions" className="relative w-full bg-background py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.02] dark:opacity-[0.05]" style={{
      backgroundImage: `linear-gradient(to right, var(--color-secondary) 1px, transparent 1px), linear-gradient(to bottom, var(--color-secondary) 1px, transparent 1px)`,
      backgroundSize: '3rem 3rem'
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-4 italic">
            Common Questions
          </h2>
          <p className="font-default text-lg text-muted-foreground max-w-2xl mx-auto">
            Clarity and transparency regarding your protection. Everything you need to know about our simplified life insurance process.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-6">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-b border-border bg-transparent rounded-md overflow-hidden transition-all duration-500 data-[state=open]:bg-card/30 shadow-sm">
              <AccordionTrigger className="px-6 py-6 hover:bg-accent/20 hover:no-underline group">
                <div className="flex items-center gap-6 text-left w-full pr-4">
                  <span className="font-serif text-5xl md:text-6xl font-light text-transparent [-webkit-text-stroke:1px_var(--color-secondary)] opacity-30 group-hover:opacity-60 transition-opacity select-none shrink-0">
                    {faq.number}
                  </span>
                  <span className="font-default text-lg md:text-xl font-medium text-foreground group-hover:text-primary transition-colors tracking-wide">
                    {faq.question}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-8 pt-2">
                <div className="pl-[5.5rem] md:pl-[6.5rem]">
                  <p className="font-default text-base text-muted-foreground leading-relaxed max-w-2xl">
                    {faq.answer}
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-12 text-center">
          <Link to="/HomePage" className="font-default text-sm text-secondary hover:text-primary transition-colors underline underline-offset-4">
            Still have questions? Return to the questionnaire
          </Link>
        </div>
      </div>
    </section>;
}